import type { FC, ReactNode } from "react";
import React from "react";
import { ArrowLeftIcon } from "src/constants/icons";
import Logo from "src/ui/assets/icons/Logo";
import LogoStacked from "src/ui/assets/icons/LogoStacked";
import Translate from "../Translate/Translate";
import {
  BackButton,
  BackLabel,
  Brand,
  BrandLogo,
  CustomLogo,
  End,
  Header,
  PartnerLogo,
  ProgressFill,
  ProgressTrack,
  Start
} from "./AppHeader.styled";
import HeaderHelp from "./HeaderHelp";

interface AppHeaderProps {
  progress?: number;
  help?: boolean;
  onBack?: () => void;
  partnerLogo?: string;
  customLogo?: string;
  partnerLogoSize?: "large" | "default";
  actions?: ReactNode;
}

const NineLogo: FC<{ stacked: boolean }> = ({ stacked }) => (
  <BrandLogo role="img" aria-label="9am Health" $stacked={stacked}>
    {stacked ? <LogoStacked /> : <Logo />}
  </BrandLogo>
);

const AppHeader: FC<AppHeaderProps> = ({
  progress,
  help = true,
  onBack,
  partnerLogo,
  customLogo,
  partnerLogoSize = "default",
  actions
}) => (
  <Header>
    <Start>
      {onBack && (
        <BackButton type="button" onClick={onBack}>
          <ArrowLeftIcon />
          <BackLabel>
            <Translate msg="back" />
          </BackLabel>
        </BackButton>
      )}
    </Start>
    <Brand>
      {customLogo ? (
        <CustomLogo src={customLogo} alt="" />
      ) : (
        <NineLogo stacked={Boolean(partnerLogo)} />
      )}
      {!customLogo && partnerLogo && (
        <PartnerLogo $large={partnerLogoSize === "large"}>
          <img src={partnerLogo} alt="" />
        </PartnerLogo>
      )}
    </Brand>
    <End>
      {actions}
      {help && <HeaderHelp />}
    </End>
    {progress !== undefined && (
      <ProgressTrack>
        <ProgressFill $progress={progress} />
      </ProgressTrack>
    )}
  </Header>
);

export default AppHeader;
